import { TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { deburr } from 'lodash';
import { useEffect, useState } from 'react';
import { CustomList } from './custom-list.component';
import { useStyles } from './styles';
import { intersection, not } from './utils';

const sortUsers = (a, b) => {
    if (a.user.name.toLowerCase() > b.user.name.toLowerCase()) {
        return 1
    } else if (a.user.name.toLowerCase() < b.user.name.toLowerCase()) {
        return -1
    } else {
        return 0
    }
};

export default function UserTransferList({ data, selected, setSelected, refresh, disabled, ...props }) {

    const styles = useStyles();
    const [checked, setChecked] = useState([]);
    const [users, setUsers] = useState([]);
    const [value, setValue] = useState('')

    useEffect(() => setUsers(data.sort(sortUsers)), [data])

    const usersChecked = intersection(checked, users);
    const selectedUsersChecked = intersection(checked, selected);

    const handleCheckedSelected = () => {
        setSelected(selected.concat(usersChecked).sort(sortUsers));
        setUsers(not(users, usersChecked).sort(sortUsers));
        setChecked(not(checked, usersChecked).sort(sortUsers));
    };

    const handleCheckedUsers = () => {
        setUsers(users.concat(selectedUsersChecked).sort(sortUsers));
        setSelected(not(selected, selectedUsersChecked).sort(sortUsers));
        setChecked(not(checked, selectedUsersChecked).sort(sortUsers));
    };
    const textFilter = (text) => {
        setValue(text)
        setUsers(data.filter(item => deburr(item.user.name.trim().toLowerCase()).includes(deburr(text.trim().toLowerCase()))))
    }

    return (
        <>
            <Grid container justifyContent='space-around'>
                <Grid item xs={11}>
                    <TextField
                        fullWidth
                        label={'Nome do usuário'}
                        placeholder={'Insira um nome'}
                        variant={'filled'}
                        disabled={disabled}
                        value={value}
                        style={{ marginBottom: '16px' }}
                        onInput={(event) => textFilter(event.target.value)}
                    />
                </Grid>
            </Grid>
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                className={styles.root}
            >
                <Grid item xs={5}>
                    <CustomList
                        title={'Usuários'}
                        items={users}
                        styles={styles}
                        checked={checked}
                        setChecked={setChecked}
                        disabled={disabled}
                    />
                </Grid>

                <Grid item xs={1}>
                    <Grid container direction="column" alignItems="center">
                        <Button
                            variant="contained"
                            size="small"
                            className={styles.button}
                            onClick={handleCheckedSelected}
                            disabled={usersChecked.length === 0 || disabled}
                            aria-label="move selectedUsers selectedUsers"
                        >
                            &gt;
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            className={styles.button}
                            onClick={handleCheckedUsers}
                            disabled={selectedUsersChecked.length === 0 || disabled}
                            aria-label="move selectedUsers users"
                        >
                            &lt;
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={5}>
                    <CustomList
                        title={'Selecionados'}
                        items={selected}
                        styles={styles}
                        checked={checked}
                        setChecked={setChecked}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
        </>
    );
}